module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon13.png?ba94d2c6";